module.exports = __webpack_public_path__ + "qr_code_ios_plp.0356dd4.png";